import React from 'react';

import './ProductListingPage.css';


function productListingPage (props) {
 
return (

  

		<div className="col-xs-12 productListing">
    <h2>{props.product.productName}</h2>
    <img src={props.product.productMainImage} alt= {props.product.productName} width="230" height="250"/><p></p>
    <p className="price"> ₹ {props.product.amazonListPrice} </p>
       <button type="button" className="btn btn-success "> <a className="go-to-store-button-link" href={`/${props.product.productCategory}/${props.product.productURL}`}>View Product</a> </button> 

		</div>
   
		



   
    
    
        

    
    );
}

export default productListingPage;